var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconClass && _vm.useAsBackgroundImage)?_c('div',{class:`flag-${_vm.iconClass.toLowerCase().replace(' ', '-')}`}):(_vm.iconClass && _vm.useAsImageSourceOnFallback)?_c('img',{class:_vm.iconClass,attrs:{"alt":"(icon)"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }